import * as React from 'react';
import { useSelector } from 'react-redux';
import UserMenuButton from './UserMenuButton';
import { getUserProfile } from '../../store';
import { useTranslation } from 'react-i18next';
const UserReportButton = ({ sentryInstance }) => {
    const { t } = useTranslation();
    const userProfile = useSelector(getUserProfile);
    if (!sentryInstance || !userProfile)
        return null;
    const sendReport = () => {
        const message = `USER: ${userProfile.firstName} ${userProfile.lastName} - ${userProfile.email} sent a feedback.`;
        const eventId = sentryInstance.captureException(message);
        console.log('[SENTRY]', message, eventId);
        sentryInstance.showReportDialog({
            eventId,
            user: {
                ...userProfile,
                email: userProfile.email,
                name: `${userProfile.firstName} ${userProfile.lastName}`,
            },
            title: t('common:sentry_title'),
            subtitle: t('common:sentry_subtitle'),
            subtitle2: t('common:sentry_subtitle_2'),
            labelName: t('common:sentry_label_name'),
            labelEmail: t('common:sentry_label_email'),
            labelComments: t('common:sentry_label_comments'),
            labelClose: t('common:close'),
            labelSubmit: t('common:submit'),
            successMessage: t('common:sentry_feedback_sent'),
            onLoad: () => {
                try {
                    const messageTextArea = document.querySelector('.sentry-error-embed textarea');
                    const poweredBy = document.querySelector('.sentry-error-embed .powered-by');
                    if (messageTextArea) {
                        messageTextArea.setAttribute('placeholder', t('common:sentry_placeholder_message'));
                    }
                    if (poweredBy) {
                        const poweredByText = document.createElement('span');
                        poweredByText.innerText = t('common:sentry_powered_by');
                        poweredBy.childNodes[0].replaceWith(poweredByText);
                    }
                }
                catch (err) {
                    console.error(err);
                }
            },
        });
    };
    return (React.createElement(UserMenuButton, { icon: 'alarm', onClick: sendReport, "data-testid": 'report' }, t('common:send_report')));
};
export default UserReportButton;
//# sourceMappingURL=UserReportButton.js.map